import { APPROVED_ORDER_STATUSES, ORDERS_PER_CYCLE } from "./constants";

export const getPurchasePoints = (order) => {
  const amount = Number(order?.amountOrder) || 0;
  return amount * 0.5;
};

const sortPurchasesDesc = (orders) =>
  [...orders].sort((left, right) => new Date(right.date) - new Date(left.date));

export const getApprovedPurchases = (orders) =>
  (orders || []).filter((order) => APPROVED_ORDER_STATUSES.includes(order.status));

export const annotatePurchases = (orders, currentCycle, ordersInCycle) => {
  const sorted = sortPurchasesDesc(getApprovedPurchases(orders));
  const inCurrent = Math.max(0, Number(ordersInCycle) || 0);
  const cycleNumber = Math.max(1, Number(currentCycle) || 1);

  return sorted.map((order, index) => {
    let cycle = cycleNumber;
    if (index >= inCurrent) {
      const cyclesBack = Math.floor((index - inCurrent) / ORDERS_PER_CYCLE) + 1;
      cycle = Math.max(1, cycleNumber - cyclesBack);
    }

    return {
      ...order,
      extrapayPoints: getPurchasePoints(order),
      extrapayCycle: cycle,
    };
  });
};

export const getCurrentCyclePurchases = (annotatedPurchases, ordersInCycle) => {
  const count = Math.max(0, Number(ordersInCycle) || 0);
  return annotatedPurchases.slice(0, count);
};
